import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoWrapper, LogoImage, Imgs } from '../styles'; 

const Logo = ({ alt, width, height, style }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/'); 
  };

  return (
    <LogoWrapper width={width} height={height} style={style} onClick={handleLogoClick}>
      <LogoImage src={Imgs.logo} alt={alt} />
    </LogoWrapper>
  );
};

export default Logo;
